import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import * as moment from 'moment'
import { Constants } from 'src/app/models/constants'
import { QRButton } from 'src/app/models/qr-button.model'
import { QRDropdown } from 'src/app/models/qr-dropdown.model'
import { RrhhAgentDetail, RrhhLeaveReasons } from 'src/app/models/rrhh.model'
import { RrhhAgentService } from 'src/app/services/rrhh/rrhh-agents.service'
import { SnackbarService } from 'src/app/services/snackbar.service'
import { environment } from '@base/environments/environment'
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model'
import { UtilsService } from '@base/src/app/services/utils.service'

export interface Reservation {
  reservationDate: string
  address: string
  mlsId: string
  state: string
}

@Component({
  selector: 'app-rrhh-remove-agent',
  templateUrl: './rrhh-remove-agent.component.html',
  styleUrls: ['./rrhh-remove-agent.component.scss']
})
export class RrhhRemoveAgentComponent implements OnInit {
  @Output() change: EventEmitter<any> = new EventEmitter<any>()
  value!: {
    leaveReasons: RrhhLeaveReasons[]
    agentDetail: RrhhAgentDetail
    loggedUser: string
    onlyQR?: boolean
  }
  agentDetail!: RrhhAgentDetail
  qrStatusActive = false
  agentFullName = ''

  readonly NODE = environment.node
  readonly NODE_AR = Constants.TENANT_ID_AR
  readonly NODE_EC = Constants.TENANT_ID_EC
  readonly NODE_PY = Constants.TENANT_ID_PY
  readonly NODE_GLOBAL = Constants.TENANT_ID_GLOBAL
  readonly NODE_DO = Constants.TENANT_ID_DO

  /*
  **********************************
  /////// ATRIBUTOS DE BAJA ////////
  **********************************
  estateDate  ==> altaRMX fecha
  downDateRMX ==> bajaRMX fecha
  beginDate   ==> altaQR fecha
  downDateQR  ==> bajaQR fecha
  statusRMX ==> estado RMX ('Activo')
  status ==> Estado QR ('Activo')
  
  
  ************************************
  /////// BAJA RMX - ATRIBUTO ////////
  ************************************
  reqRau:{
    create: false,
    delete: true
    deleteReasonType: number ==> motivo de baja
    deleteReasonDetail: '' ==> descr. del motivo
    }
  */

  visibleFormRMX = true
  visibleSectionRemoveQR = false
  visibleFormQR = false

  disabledButtonRemoveRMX = true
  disabledButtonRemoveQR = true

  successAgentRemoveRMX = false
  successAgentRemoveQR = false

  errorsRemoveQR = [
    {
      id: 'team',
      msg: '',
      error: false
    },
    {
      id: 'reservas',
      msg: '',
      error: false
    },
    {
      id: 'captaciones',
      msg: '',
      error: false
    }
  ]

  //Validaciones para habilitar el botón final "Sí ,dar de baja"
  validationsRemoveRMX: {
    motives: boolean
    motivesDescription: boolean
    file: boolean
  } = {
    motives: false,
    motivesDescription: false,
    file: this.NODE === this.NODE_DO ? true : false
  }
  validationsRemoveQR: { date: boolean } = {
    date: false
  }

  // Data para PUT de la baja
  dataRemoveRMX = {
    motives: '',
    motiveDescription: '',
    file: ''
  }
  dataRemoveQR = {
    qrDesactivation: false,
    dateQrDesactivation: ''
  }

  //Motivo de baja RMX
  dropdown: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_MEDIUM,
    placeholder: 'Seleccionar',
    options: []
  }

  buttonAddFile: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Agregar archivos',
    icon: Constants.ICONS.PLUS
  }

  todayDate = moment().format('YYYY-MM-DD') // Fecha actual
  dateSelected = this.todayDate
  errorDateInput = false

  visibleDetailTextarea = false

  readonly FILE_WARNING =
    'Archivos de hasta 10MB en formato PDF.'
  readonly FILE_ERROR_SIZE = 'El archivo debe ser menor a 10MB'
  readonly FILE_ERROR_TYPE = 'El archivo debe ser PDF.'
  uploadedFile = false
  fileRemoveRMX: File | undefined
  fileName = ''
  fileWarning = this.FILE_WARNING
  allowedFormats = [
    // Documentos de Word
    // 'application/msword',
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    // Documentos de PDF
    'application/pdf',
    // Archivos de texto
    // 'text/plain',
    // Archivos de hoja de cálculo
    // 'application/vnd.ms-excel',
    // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    // Formato para archivos CSV
    // 'text/csv',
    // Imágenes
    // 'image/jpeg',
    // 'image/jpg',
    // 'image/png'
  ]

  agentName = ''
  textareaValue = ''
  canBeDisabled = false
  canBeDisabledMsg = ''
  isLoading = false
  isLoadingRestrictive = false

  buttonDeleteFile: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true
  }

  //Formulario Captaciones Activas
  hideCaptacionesActivas = false //Clickeo en inactivar/no captaciones

  buttonAceptCaptaciones: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Inactivar captaciones'
  }

  buttonCancelCaptaciones: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'No'
  }

  buttonAceptRemoveRMX: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Sí, dar de baja RMX'
  }

  buttonWantToRemoveQR: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Dar de baja'
  }

  buttonCancelWantToRemoveQR: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Salir'
  }

  buttonGoToReservations: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir a reservas'
  }

  buttonCancelBaja: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar baja'
  }

  datePicker: QRDatePicker = {
    date: this.todayDate,
    maxDate: this.todayDate,
    isDisplayedUp: true,
    calendarWidth: 200
  }

  reservations: Reservation[] = []
  isDateHide: boolean = false
  isAgentClean: boolean = false
  catchmentCount: number = 0

  constructor (
    private readonly rrhhServiceAgents: RrhhAgentService,
    private readonly snackbarService: SnackbarService,
    public readonly utilsService: UtilsService
  ) {}

  ngOnInit (): void {
    if (this.value) {
      if (this.value.onlyQR) {
        this.visibleSectionRemoveQR = true
        this.successAgentRemoveQR = false
      }

      if (this.value.leaveReasons) {
        const list: string[] = []
        this.value.leaveReasons.forEach((e: any) => {
          list.push(e.value)
        })
        this.dropdown = { ...this.dropdown, options: list }
      }

      if (this.value.agentDetail) {
        this.agentDetail = this.clearDataToPut(this.value.agentDetail)

        this.qrStatusActive = this.agentDetail.status == 'Activo'
        this.agentFullName =
          this.agentDetail.name + ' ' + this.agentDetail.lastName
      }

      if (this.value.loggedUser) {
        this.agentDetail.loggedUser = this.value.loggedUser
      }

      this.dataRemoveQR.dateQrDesactivation = this.dateSelected
    }
  }

  //***** Servicio canBeDisabled ******
  async canBeDisabledService () {
    this.isLoadingRestrictive = true
    const param = this.agentDetail.id + '/canBeDisabled'
    await this.rrhhServiceAgents
      .get(param)
      .then(response => {
        const msg = response.message
        if (this.NODE !== this.NODE_EC) {
          //Nuevo flujo de baja de Agentes Inactivos (ar-gl-py)
          this.catchmentCount = response.data.catchmentCount
          if (response?.data?.reservations) {
            this.reservations = response.data.reservations
            //Procede con la baja en AR o PY si no pertenece a team y no tiene reservas.
          } else if (
            response.data.reservations == null &&
            (response.data.message?.includes('captaciones') ||
              response.data.message === '')
          ) {
            this.isAgentClean = true
            this.onAgentRemoveQR()
          }
        }

        let index: number | undefined = undefined

        switch (true) {
          case msg.includes('Agente activo en el team'):
            index = 0
            break

          case msg.includes('reservas'):
            index = 1
            break

          case msg.includes('captaciones activas'):
            this.errorsRemoveQR[2].msg =
              'El agente disponía de captaciones activas. ¿Desea poner inactivas sus captaciones?'
            this.errorsRemoveQR[2].error = true
            index = 2
            break

          case msg.includes(''):
            index = 3
            break
        }

        if (index == 0 || index == 1) {
          this.errorsRemoveQR[index].msg = msg
          this.errorsRemoveQR[index].error = true
        }

        this.canBeDisabled = !(index == 0 || index == 1)

        this.canBeDisabledMsg =
          index != undefined ? this.errorsRemoveQR[index].msg : ''

        if (this.canBeDisabled) {
          this.visibleFormQR = true
        }
        this.isLoadingRestrictive = false
        this.checkFormQR()
      })
      .catch(() => {
        this.isLoadingRestrictive = false
      })
  }

  dropdownChange (selected: string): void {
    const index = this.value.leaveReasons.findIndex(
      (obj: any) => obj.value === selected
    )
    this.visibleDetailTextarea = this.value.leaveReasons[index].reqDetail
    this.dataRemoveRMX.motives = selected

    this.validationsRemoveRMX.motives = true
    this.validationsRemoveRMX.motivesDescription = true

    if (!this.visibleDetailTextarea) {
      this.dataRemoveRMX.motiveDescription = ''
    } else {
      this.validationsRemoveRMX.motivesDescription = false
    }

    this.checkFormRMX()
  }

  onTextareaChange ($event: any) {
    this.dataRemoveRMX.motiveDescription = $event
    this.validationsRemoveRMX.motivesDescription = $event != ''
    this.checkFormRMX()
  }

  addFile ($event: any) {
    this.fileRemoveRMX = $event.target.files[0]

    if (this.fileRemoveRMX) {
      if (
        this.fileRemoveRMX.size > 10 * 1024 * 1024 ||
        !this.allowedFormats.includes(this.fileRemoveRMX.type)
      ) {
        this.fileWarning =
          this.fileRemoveRMX.size > 10 * 1024 * 1024
            ? this.FILE_ERROR_SIZE
            : this.FILE_ERROR_TYPE
        this.uploadedFile = false
        this.validationsRemoveRMX.file = false
        this.dataRemoveRMX.file = ''
      } else {
        this.fileWarning = ''
        this.fileName = this.fileRemoveRMX
          ? this.utilsService.sanitizeFileName(this.fileRemoveRMX.name)
          : ''

        const reader = new FileReader()
        reader.onloadend = () => {
          const result = reader.result as string
          this.dataRemoveRMX.file = result
        }

        reader.readAsDataURL(this.fileRemoveRMX)
        this.uploadedFile = true
        this.validationsRemoveRMX.file = true
      }
    }

    this.checkFormRMX()
  }

  deleteFile () {
    this.fileWarning = this.FILE_WARNING
    this.fileRemoveRMX = undefined
    this.dataRemoveRMX.file = ''
    this.uploadedFile = false
    this.validationsRemoveRMX.file = this.NODE === this.NODE_DO ? true : false
    this.checkFormRMX()
  }

  //picker de fecha de baja QR
  datepickerChange (e: string): void {
    const datePicked = moment(e)
    if (datePicked.isAfter(this.todayDate)) {
      this.errorDateInput = true
      this.validationsRemoveQR.date = false
      this.dataRemoveQR.dateQrDesactivation = ''
    } else {
      this.errorDateInput = false
      this.dataRemoveQR.dateQrDesactivation = e
      this.validationsRemoveQR.date = true
    }

    this.checkFormQR()
  }

  inactivarCaptaciones (b: number) {
    if (b == 0) {
      this.closeModal()
    } else {
      this.isLoadingRestrictive = true
      this.hideCaptacionesActivas = true

      //servicio
      this.rrhhServiceAgents
        .put(this.agentDetail, '?updateCatchments=1')
        .then(r => {
          this.snackbarService.openSnackBar('✅ Captaciones inactivadas', '')
          this.isLoadingRestrictive = false
          this.closeModal()
        })
        .catch(err => {
          this.isLoadingRestrictive = false
          this.snackbarService.openSnackBar('⛔ Ocurrió un error', '')
        })
    }
  }

  checkFormRMX () {
    let enableDesactivationRMX = true

    Object.keys(this.validationsRemoveRMX).forEach((key: any) => {
      enableDesactivationRMX =
        enableDesactivationRMX &&
        this.validationsRemoveRMX[key as keyof typeof this.validationsRemoveRMX]
    })

    this.disabledButtonRemoveRMX = !enableDesactivationRMX
  }

  checkFormQR () {
    this.disabledButtonRemoveQR = !this.validationsRemoveQR.date
  }

  onAgentRemoveRMX () {
    if (!this.disabledButtonRemoveRMX) {
      const originalAgentDetail = this.agentDetail //Por si falla la baja RMX
      const bodyRMX = this.agentDetail
      this.isLoading = true
      //SETEO BODY
      const idLeaveReasonObj = this.value.leaveReasons.find(
        e => e.value == this.dataRemoveRMX.motives
      )
      const reqRau = {
        create: false,
        delete: true,
        deleteReason: idLeaveReasonObj?.id,
        deleteReasonDetail: this.dataRemoveRMX.motiveDescription
      }

      bodyRMX.civilStatus = bodyRMX.civilStatus?.toUpperCase()
      if (bodyRMX.civilStatus === 'UNION DE HECHO') {
        bodyRMX.civilStatus = 'UNION_DE_HECHO'
      }
      if (bodyRMX.civilStatus === 'UNION LIBRE') {
        bodyRMX.civilStatus = 'UNION_LIBRE'
      }

      bodyRMX.reqRau = reqRau
      bodyRMX.downDateRMX = this.todayDate
      bodyRMX.statusRMX = 'Inactivo'
      if (bodyRMX.documents.length > 0) {
        bodyRMX.documents.push(
          this.NODE === this.NODE_AR || this.NODE === this.NODE_DO
            ? {
                name: this.fileName,
                path: this.dataRemoveRMX.file,
                documentType: 8
              }
            : {
                name: this.fileName,
                path: this.dataRemoveRMX.file
              }
        )
      }

      //PUT
      this.rrhhServiceAgents
        .put(bodyRMX, '')
        .then(r => {
          this.agentDetail = { ...bodyRMX }
          this.isLoading = false
          this.successAgentRemoveRMX = true
          this.visibleFormRMX = false
          this.visibleSectionRemoveQR = true
        })
        .catch(err => {
          setTimeout(() => {
            this.isLoading = false
            this.agentDetail = { ...originalAgentDetail }
            this.snackbarService.openSnackBar(
              '⛔ Ocurrió un error en la baja RMX',
              ''
            )
          }, 400)
        })
    }
  }

  onCheckAgentRemoveQR () {
    if (!this.errorDateInput) {
      this.isLoadingRestrictive = true
      this.isDateHide = true
      setTimeout(async () => {
        await this.canBeDisabledService()
        if (this.NODE === this.NODE_EC) {
          if (this.canBeDisabledMsg == '' || this.errorsRemoveQR[2].error) {
            this.onAgentRemoveQR()
          }
        }
      }, 400)
    }
  }

  onAgentRemoveQR () {
    if (!this.errorDateInput) {
      this.visibleSectionRemoveQR = false
      this.isLoadingRestrictive = true
      this.agentDetail.status = 'Inactivo'

      this.agentDetail.downDateQR = this.dataRemoveQR.dateQrDesactivation
      this.agentDetail.reqRau = {
        create: false,
        delete: false,
        deleteReason: null,
        deleteReasonDetail: ''
      }

      this.agentDetail.civilStatus = this.agentDetail.civilStatus?.toUpperCase()
      if (this.agentDetail.civilStatus === 'UNION DE HECHO') {
        this.agentDetail.civilStatus = 'UNION_DE_HECHO'
      }
      if (this.agentDetail.civilStatus === 'UNION LIBRE') {
        this.agentDetail.civilStatus = 'UNION_LIBRE'
      }

      //PUT
      this.rrhhServiceAgents
        .put(this.agentDetail, '')
        .then(() => {
          this.visibleFormQR = false
          this.isLoadingRestrictive = false
          this.successAgentRemoveQR = true
        })
        .catch(err => {
          setTimeout(() => {
            this.isLoadingRestrictive = false
            console.error('Error en la baja QR:', err)
            this.snackbarService.openSnackBar(
              '⛔ Ocurrió un error en la baja QR',
              ''
            )
          }, 400)
        })
    }
  }

  closeModal () {
    this.change.emit('close')
  }

  goToReservations () {
    window.location.href =
      environment.oldFrontUrl +
      '/stats/list?filterBy=2&filterReservaBy=4,5&filterByAgente=' +
      this.agentDetail.id
    this.closeModal()
  }

  clearDataToPut (obj: RrhhAgentDetail): RrhhAgentDetail {
    const detailsObj = obj
    if ('deleteReasonType' in detailsObj) {
      delete detailsObj.deleteReasonType
    }
    if ('deleteReasonDetail' in detailsObj) {
      delete detailsObj.deleteReasonDetail
    }
    if ('rauRequest' in detailsObj) {
      delete detailsObj.rauRequest
    }
    if (
      detailsObj.agentVerifications &&
      detailsObj.agentVerifications.length > 0
    ) {
      const array: any = []
      detailsObj.agentVerifications.forEach((e: any) => {
        if (e.agencyVerificationId) {
          array.push(e.agencyVerificationId)
        } else {
          array.push(e)
        }
      })
      detailsObj.agentVerifications = array
    }
    return detailsObj
  }

  showActiveCaptationsError (): boolean {
    const HAS_CAPTATIONS = this.errorsRemoveQR[2].error
    const IS_ERROR_IN_CAPTATIONS =
      HAS_CAPTATIONS &&
      !this.hideCaptacionesActivas &&
      this.catchmentCount !== 0
    const SUCCESS_CONDITION =
      this.successAgentRemoveQR && this.catchmentCount !== 0
    const IS_ENV_EC = this.NODE === this.NODE_EC && HAS_CAPTATIONS
    return IS_ERROR_IN_CAPTATIONS || SUCCESS_CONDITION || IS_ENV_EC
  }
}
